module.exports = __webpack_public_path__ + "3e9520313f74f6dabdbef0c061700689.svg";